import React, { useEffect, useContext, useState } from 'react'
import { Typography, Box, IconButton, Card, CardHeader, Stack, CardContent } from '@mui/material'
import { ButtonHorarioMobile, ScheduleDaySlider } from '../../../Complex'
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5'
import AlertDescontoProgressivo from './AlertDescontoProgressivo'
import { disabledHorarios } from '../../../Complex/ButtonHorario/functions'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { IoIosArrowBack } from 'react-icons/io'
import { daysFromToday, getSportNames } from '../../../../utils/functions'
import ResumoAgendConf from './ResumoAgendConf'
import { Loading } from '../../../Simple'
import moment from 'moment'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'
import RouterHook from '../../../../contexts/RouterHook'
import { ToastMessages } from '../../../ToastMessages'

export default function GradeHorarios() {
  const { userUCtx } = useContext(UsuarioContext)
  const { sttPg, loads, actionsCtxEmps } = useContext(EmpresasContext)
  const { sttCtxAgend } = useContext(AgendamentoContext)
  const serverRouter = RouterHook()

  const reagendamento = sttCtxAgend.reagendamento

  const FormaPagamentoIncompativelReagendamento = quadra => {
    const tipoPagamento = quadra.regraAgendamento.tipoPagamento
    if (quadra.idquadra === 474)
      switch (tipoPagamento) {
        case 'SINAL':
          if (
            reagendamento.valorTotal !== reagendamento.valorAPagar &&
            reagendamento.valorRealizado !== 0 &&
            reagendamento.valorAPagar !== 0
          )
            return false
          break
        case 'TOTAL':
          if (
            reagendamento.valorTotal !== reagendamento.valorAPagar &&
            reagendamento.valorRealizado !== 0 &&
            reagendamento.valorAPagar !== 0
          )
            return true
          break
        case 'AMBOS':
          break
      }

    if (Object.keys(reagendamento).length > 0) {
      const recebePgtoLocal =
        quadra.regraAgendamento.recebimentos_dinheiro_avulso ||
        quadra.regraAgendamento.recebimentos_maquina_local_avulso
      switch (reagendamento.formaPagamento) {
        case 'MAQUINA_CARTAO':
          if (recebePgtoLocal) return false
          else return true
        case 'LOCAL':
          if (recebePgtoLocal) return false
          else return true
        case 'DINHEIRO':
          if (recebePgtoLocal) return false
          else return true
        case 'PIX':
          if (quadra.regraAgendamento.recebimentos_pix_avulso) return false
          else return true
        case 'CARTAO_CREDITO':
          if (quadra.regraAgendamento.recebimentos_cartao_avulso) return false
          else return true
      }
    }
  }

  const [invalidGrade, setInvalidGrade] = useState(false)

  useEffect(() => {
    if (!sttPg.selectedQuadra) {
      actionsCtxEmps.handleModeSttPg({ modePg: 'quadras' })
      return
    }

    if (sttPg.selectedHorarios.length > 0) {
      let flag = true
      for (let horario of sttPg.selectedQuadra?.horarios || []) {
        if (sttPg.selectedHorarios[0].idgrade === horario.idgrade) {
          flag = false
          break
        }
      }
      setInvalidGrade(flag)
    } else setInvalidGrade(false)
  }, [sttPg.selectedHorarios, sttPg.selectedQuadra])

  const VerificaDesativaGrades = () => {
    if (sttPg.selectedQuadra?.desativaGrades.length) {
      for (let item of sttPg.selectedQuadra?.desativaGrades || []) {
        if (
          moment(sttPg.selectedDay).isBetween(
            moment(item.dataInicio),
            moment(item.dataFim),
            'days',
            '[]',
          )
        ) {
          return true
        }
      }
    } else return false
  }

  const handleHorarioChange = (horario, isChecked) => {
    actionsCtxEmps.handleSelectHorario(horario, isChecked)
  }

  const handleQuadra = qdr => {
    const diff = daysFromToday(sttPg.selectedDay)
    if (
      qdr.regraAgendamento.maximoTempoAgendamento > 0 &&
      diff >= qdr.regraAgendamento.maximoTempoAgendamento
    ) {
      ToastMessages.unavailableCourtDate()
      const maxDaysAhead = qdr.regraAgendamento.maximoTempoAgendamento
      const day = moment().add(maxDaysAhead - 1, 'days')
      actionsCtxEmps.handleSttPg('selectedDay', day)
    }

    actionsCtxEmps.clearSelectedHorarios()
    actionsCtxEmps.BuscarGradeHorarios(qdr)
  }

  // Ref para guardar o último GMT que já mostramos
  const lastGmtShown = React.useRef(undefined)
  // Ref para bloquear repetição de toast de fuso no mesmo ciclo
  const toastInThisCycle = React.useRef(false)
  // Ref para bloquear repetição do aviso de horário errado
  const hasShownTimeError = React.useRef(false)

  // Função que verifica se a empresa tem GMT diferente do usuário
  function VerificaGmtEmpresa() {
    const gmtEmpresa = sttPg.empresa?.gmt
    const gmtUsuario = moment().utcOffset() / 60 // GMT do usuário em horas
    return gmtEmpresa !== gmtUsuario
  }

  // useEffect que dispara toasts para:
  // 1) sttPg.validData.isValid === false (horário do dispositivo errado)
  // 2) mudança de sttPg.empresa.gmt com mismatch de fuso
  useEffect(() => {
    // Resetar bloqueio de toast de fuso a cada vez que entramos no efeito
    toastInThisCycle.current = false

    // 1) Verifica primeiro se o horário do dispositivo está errado:
    if (
      sttPg.validData &&
      sttPg.validData.isValid === false &&
      hasShownTimeError.current === false
    ) {
      // Dispara o toast apenas uma vez
      hasShownTimeError.current = true
      ToastMessages.persistentWarning(
        'Atenção: O horário de seu dispositivo parece estar configurado de maneira incorreta, utilize as configurações automáticas para evitar transtornos.',
      )
      // Não retornamos aqui pois ainda podemos precisar avisar sobre GMT
    }

    // 2) Agora verifica mismatch de GMT da empresa
    if (!sttPg.empresa || sttPg.empresa.gmt == null) return

    const gmtAtual = sttPg.empresa.gmt

    // Só dispara se:
    // a) gmtAtual mudou desde a última vez que mostramos
    // b) realmente há mismatch (VerificaGmtEmpresa() = true)
    // c) ainda não mostramos neste ciclo (toastInThisCycle.current === false)
    if (
      gmtAtual !== lastGmtShown.current &&
      VerificaGmtEmpresa() &&
      toastInThisCycle.current === false
    ) {
      toastInThisCycle.current = true
      lastGmtShown.current = gmtAtual

      ToastMessages.persistentWarning(
        `Atenção: O fuso horário de seu dispositivo difere do fuso deste centro esportivo (${gmtAtual === -3 ? 'Horário de Brasília' : `GMT${gmtAtual}`}).`,
      )
    }
  }, [sttPg.empresa?.gmt, sttPg.validData?.isValid])

  useEffect(() => {
    actionsCtxEmps.BuscarGradeHorarios()
  }, [sttPg.selectedDay])

  return (
    <>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          height: '92vh',
          width: '100%',
          overflow: 'hidden',
          boxShadow: 'none',
          '&.MuiCard-root': { borderRadius: 0 },
        }}
      >
        <CardHeader
          sx={{ p: 1, width: '100%' }}
          title={
            <Typography
              variant='h5'
              fontWeight='bold'
              sx={{
                width: 'auto',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {sttPg.selectedQuadra?.descricao}
            </Typography>
          }
          subheader={
            <Typography variant='subtitle1'>
              {getSportNames(sttPg.selectedQuadra?.categoriasEsporte)}
            </Typography>
          }
          avatar={
            <IconButton
              onClick={() =>
                Object.keys(sttCtxAgend.reagendamento).length === 0
                  ? actionsCtxEmps.handleSttPg('modePg', 'quadras')
                  : serverRouter('agendamento', sttCtxAgend.reagendamento.idpedido)
              }
              sx={{ color: 'primary.main' }}
            >
              <IoIosArrowBack size='25px' />
            </IconButton>
          }
        />
        <Stack direction='row' spacing={1} sx={stDesk.containStack}>
          {sttPg.empresa.quadras.map((qdr, index) => (
            <button
              key={index}
              style={
                qdr.idquadra === sttPg.selectedQuadra?.idquadra
                  ? stDesk.containQdrSelected
                  : FormaPagamentoIncompativelReagendamento(qdr)
                    ? stDesk.containQdrDisabled
                    : stDesk.containQdr
              }
              onClick={() => {
                FormaPagamentoIncompativelReagendamento(qdr)
                  ? ToastMessages.mismatchCourtPaymentMethodOnRescheduling()
                  : handleQuadra(qdr)
              }}
            >
              <Box
                sx={{
                  backgroundImage: `url(${qdr.urlFoto + qdr.foto})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '100%',
                  width: '100%',
                }}
              />
            </button>
          ))}
        </Stack>
        <ScheduleDaySlider />
        {sttPg.selectedQuadra?.grades?.filter(grad => grad.descontoProgressivo !== null).length >
        0 ? (
          <AlertDescontoProgressivo />
        ) : (
          <></>
        )}

        <CardContent
          sx={{
            bgcolor: 'background.monthly',
            overflow: 'auto',
            flex: 1,
            '&.MuiCardContent-root': { p: 1, borderRadius: 0 },
          }}
        >
          {loads.gradeHorarios ? (
            <div className='contain-loading'>
              <Loading text={'Carregando horários disponíveis...'} />
            </div>
          ) : sttPg.selectedQuadra?.horarios === undefined ||
            sttPg.selectedQuadra?.horarios?.length === 0 ||
            VerificaDesativaGrades() ? (
            <div className='contain-loading tw-flex-col'>
              <IoChatbubbleEllipsesOutline size={75} style={stDesk.iconNotHorarios} />
              <Typography variant='body1' sx={stDesk.textAviso}>
                Nenhum horário disponível para este dia.
              </Typography>
            </div>
          ) : (
            <>
              {sttPg.selectedQuadra?.horarios.map((horario, index) => (
                <React.Fragment key={index}>
                  <ButtonHorarioMobile
                    horario={horario}
                    isNobre={horario.nobre}
                    onChange={isChecked => handleHorarioChange(horario, isChecked)}
                    disabled={disabledHorarios(userUCtx, sttPg, horario, invalidGrade)}
                    reagendavel={
                      horario?.idpedido
                        ? sttCtxAgend.reagendamento.idpedido === horario.idpedido
                        : false
                    }
                    isSelected={sttPg.selectedHorarios.some(
                      selected => selected.idHorario === horario.idHorario,
                    )}
                  />
                </React.Fragment>
              ))}
            </>
          )}
        </CardContent>
      </Card>

      {/* Componente ResumoAgendamentoMobile mantido fixo no rodapé */}
      <ResumoAgendConf />
    </>
  )
}

const stDesk = {
  containStack: {
    mt: 1,
    display: 'flex',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    gap: 1,
    padding: '5px 15px',
    marginBottom: '10px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  containQdrSelected: {
    overflow: 'hidden',
    outline: '4px solid #FF7043',
    borderRadius: 15,
    padding: 0,
    minWidth: '90px',
    minHeight: '50px',
    transition: 'all 0.25s ease-in-out',
  },
  containQdr: {
    padding: 0,
    minWidth: '50px',
    minHeight: '50px',
    overflow: 'hidden',
    borderRadius: '100%',
    transition: 'all 0.25s ease-in-out',
  },
  containQdrDisabled: {
    padding: 0,
    width: 50,
    height: 50,
    overflow: 'hidden',
    borderRadius: '100%',
    transition: 'all 0.25s ease-in-out',
    opacity: 0.5,
  },
  textAviso: {
    color: 'gray',
    fontSize: '16px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  iconNotHorarios: {
    color: 'gray',
    textAlign: 'center',
    fontSize: '75px',
    marginBottom: '10px',
  },
}
